// plugin/pushNotifications.js
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'

export async function initPush(onToken, onNotificationTap) {
  if (!Capacitor.isNativePlatform()) return

  const permStatus = await PushNotifications.checkPermissions()
  if (permStatus.receive !== 'granted') {
    const req = await PushNotifications.requestPermissions()
    if (req.receive !== 'granted') {
      console.warn('Push permission denied')
      return
    }
  }

  await PushNotifications.register()

  PushNotifications.addListener('registration', (token) => {
    onToken(token.value) // send this to your backend
  })

  PushNotifications.addListener('registrationError', (err) => {
    console.error('Push registration error:', err)
  })

  // App was in foreground when the push arrived
  PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.log('Push received in foreground:', notification)
    // FCM does NOT show a system notification automatically in this case —
    // show your own in-app toast/banner here if you want one
  })

  // User tapped the notification (app was closed or backgrounded)
  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    onNotificationTap(action.notification.data)
  })
}